var icon = require('vue-svgicon')
icon.register({
  'ks-icon-clone': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M91 49H75v-5.57c0-3.37-2.91-5.43-6.19-5.43H36c-3.28 0-6 2.06-6 5.43v42.86c0 3.37 2.69 6.71 6 6.71h16v3.63c0 3.37 2.91 7.37 6.19 7.37H91c3.28 0 6-4 6-7.37V53.76c0-3.37-2.69-4.76-6-4.76zM37 86V45h31v4h-9.81C54.91 49 52 50.39 52 53.76V86zm53 11H59V55h31z"/><path pid="1" d="M86 35a20 20 0 0 0-40 0h5.27a14.73 14.73 0 1 1 29.46 0h-6.88L83 44.15 92.15 35z"/>'
  }
})
